module.exports = __webpack_public_path__ + "img/9788960305762.564917da.jpg";